export default "__VITE_ASSET__Ctb_1P2z__"